import IDefaultClickListener from "./IDefaultClickListener";
import RaycastIntersection from "../logic/RaycastIntersection";
import { getRoomNoteTarget } from "../interfaces/IRoomNoteTarget";
import { useRoomNoteDialogStore } from "../store/roomNoteDialogStore";

/**
 * Opens the room note dialog when a click that no command consumed hits a room label's note or add-note icon.
 * Looks through all hits because labels are drawn on top of the model, so the icon is often not the nearest hit.
 */
export default class RoomNoteClickListener implements IDefaultClickListener {

    getName(): string {
        return "RoomNoteClickListener";
    }

    defaultClick(raycastResults: RaycastIntersection[]): boolean {
        const target = raycastResults
            .map(r => getRoomNoteTarget(r.object))
            .find(t => t !== undefined);

        if (!target) return false;

        useRoomNoteDialogStore.getState().open(target.globalId, target.roomName, target.note);
        return true;
    }
}
